import clsx from 'clsx'
import React, {FC, useEffect} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import { getInitials } from '../../../../utils/streamlineSpecificHelpers'
import { useDispatch, useSelector } from 'react-redux'
import { coreConstants } from '../../../../data/redux/coreReducer'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const dispatch = useDispatch();
  const {config} = useLayout()
  const {currentUser} = useAuth()

  const {notificationSeen, notifications}: any = useSelector((state: any) => state.core)

  const resetNotification = () => {
    dispatch({
      type: coreConstants.coreNotification,
      payload: true
    });
  }

  useEffect(() => {

    //console.log(notificationSeen);
    
  }, [notificationSeen]);
  
  return (
    <div className='d-flex flex-shrink-0'>
      {/* <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
        <Search />
      </div> */}

      <div className={clsx('d-flex align-items-center ms-1 ms-lg-3 mt-6 me-3', toolbarButtonMarginClass)}>
        <div
          className={clsx('cursor-pointer symbol symbol-10px btn bg-light btn-icon rounded-pill btn-active-dark me-0', toolbarButtonHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
          onClick={resetNotification}
        >
          {notifications?.length > 0 && <span className="badge badge-circle badge-danger position-absolute fs-7 text-gray-100"
            style={{left:'-10px',top:'-5px'}}>
            {notifications?.length}
          </span>}
          {!notificationSeen && <span className="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-100 animation-blink"></span>}
          <KTSVG path='/assets/media/icons/duotune/general/gen007.svg' className='svg-icon-1 svg-icon-dark me-0 px-0 py-0' />
        </div>
        <HeaderNotificationsMenu />
      </div>

      <div
        className={clsx('d-flex align-items-end', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <h2 className='symbol symbol-50px btn bg-light-dark btn-active-dark mb-0 m-0 px-4'>
            {getInitials(`${currentUser?.first_name}`)}<KTSVG path='/assets/media/icons/duotune/arrows/arr072.svg' className='svg-icon-3 svg-icon-dark me-0 px-0 py-0' />
          </h2>
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>

      {/* {config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTSVG path='/assets/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
          </div>
        </div>
      )} */}
    </div>
  )
}

export {Topbar}
